import SelectWorkspace from '@/components/popups/SelectWorkspace'
import ActivateWorkspace from '@/components/popups/ActivateWorkspace'
import ConfirmationPopup from '@/components/popups/ConfirmationPopup'
import InitWorkspace from '@/components/popups/InitWorkspace'
export default {
  computed: {
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    lastOpenedWorkspace() {
      return this.$store.getters.lastOpenedWorkspace
    },
    activeWorkspaceList() {
      return this.$store.getters.activeWorkspaceList
    },
  },
  methods: {
    openSelectWorkspacePopup(allowCloseOnEscape = true) {
      this.$ui.popup.show({
        component: SelectWorkspace,
        allowCloseOnEscape
      }).then(v => {
        if(v && v.action === 'changeWorkspaceActivations') {
          this.openActivateWorkspacePopup()
        } else if(v && v.action === 'createWorkspace') {
          this.openInitWorkspacePopup()
        } else {
          this.validateWorkspaceAndInitApp()
        }
      })
    },
    openInitWorkspacePopup() {
      this.$ui.popup.show({
        component: InitWorkspace,
      }).then(v => {
        this.openSelectWorkspacePopup()
      })
    },
    openActivateWorkspacePopup() {
      this.$ui.popup.show({ component: ActivateWorkspace }).then(v => {
        if(v && v.action === 'deleteWorkspace') {
          this.deleteWorkspace(v.workspace)
        } else {
          this.validateWorkspaceAndInitApp()
        }
      })
    },
    validateWorkspaceAndInitApp(allowCloseOnEscape = true) {
      const lastOpenedWorkspace = this.$store.getters.lastOpenedWorkspace
      if(lastOpenedWorkspace && this.workspace === lastOpenedWorkspace) {
        return
      }
      if(lastOpenedWorkspace && this.activeWorkspaceList.filter(v => v.id.toString() === lastOpenedWorkspace.toString()).length > 0) {
        this.selectWorkspace(lastOpenedWorkspace)
        return
      }
      this.openSelectWorkspacePopup(allowCloseOnEscape)
    },
    selectWorkspace(ws) {
      this.$store.dispatch('selectWorkspace', ws).then(v => {
        this.$store.commit('setInitLoading', true)
        this.$store.dispatch('initApp').then(v => {
          console.log('Application was initialized successfully')
          this.$store.commit('setInitLoading', false)
        }).catch(e => {
          this.$store.commit('setInitLoading', false)
          this.$store.commit('setApiErrorInfo', 'При получении данных, необходимых для инициализации рабочего пространства, произошла ошибка')
        })
      })
    },
    deleteWorkspace(id) {
      this.$ui.popup.show({
        component: ConfirmationPopup,
        params: {
          title: 'Удаление рабочего пространства',
          text: 'Удаление рабочего пространства необратимо и сделает недоступным все данные в нем. Действительно удалить рабочее пространство?',
          okText: 'Удалить',
        }
      }).then(r => {
        if(r === 'ok') {
          this.$ui.toast.show({text: 'Удаление рабочего пространства запущено. Окно управления рабочими пространствами будет открыто автоматически после завершения удаления', type: 'progress'})
          this.$store.dispatch('deleteWorkspace', id).then(r => {
            this.$ui.toast.hide()
            this.openActivateWorkspacePopup()
          }).catch(e => {
            this.$store.commit('setApiErrorInfo', 'Ошибка удаления рабочего пространства')
            this.openActivateWorkspacePopup()
          })
        } else {
          this.openActivateWorkspacePopup()
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/workspace.js